import { render, staticRenderFns } from "./SalaryPayment.vue?vue&type=template&id=77baa8f4&scoped=true&"
import script from "./SalaryPayment.vue?vue&type=script&lang=js&"
export * from "./SalaryPayment.vue?vue&type=script&lang=js&"
import style0 from "./SalaryPayment.vue?vue&type=style&index=0&id=77baa8f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77baa8f4",
  null
  
)

export default component.exports